import {
    DatiqPanelPopupPosition,
    DatiqPanelPopupScrollStrategy,
} from './datiq-panel-popup.enum';
import { z } from 'zod';

export const DatiqPanelPopupSchema = z.object({
    id: z.string(),
    icon: z.string(),
    label: z.string().optional(),
    closeIcon: z.string().optional(),
    closeOnEsc: z.boolean().optional(),
    closeOnOutsideClick: z.boolean().optional(),
    opened: z.boolean().optional(),
    disabled: z.boolean().optional(),
    position: z.nativeEnum(DatiqPanelPopupPosition).optional(),
    scrollStrategy: z.nativeEnum(DatiqPanelPopupScrollStrategy).optional(),
});

export interface IDatiqPanelPopup
    extends z.infer<typeof DatiqPanelPopupSchema> {}
